(function () {
  var STORAGE_KEYS = {
    profile: 'gg_platform_profile',
    latestHarvest: 'gg_platform_latest_harvest',
    harvestLogs: 'gg_platform_harvest_logs',
    favoriteRecipes: 'gg_platform_favorite_recipes',
    recipes: 'gg_platform_recipes',
    journalEntries: 'gg_platform_journal_entries',
    cookbookProjects: 'gg_platform_cookbook_projects'
  };

  var REQUEST_TIMEOUT_MS = 12000;
  var MEMORY_STORAGE = {};
  var STORAGE_ENABLED;
  var accountStateCache = null;
  var accountStateRequest = null;
  var recipeIndexCache = {};

  var STATE_REGION_MAP = {
    'alabama': 'lower-south',
    'alaska': 'pacific-northwest',
    'arizona': 'mountain-west',
    'arkansas': 'lower-south',
    'california': 'pacific',
    'colorado': 'mountain-west',
    'connecticut': 'northeast',
    'delaware': 'mid-atlantic',
    'florida': 'southeast-coast',
    'georgia': 'southeast-coast',
    'hawaii': 'islands',
    'idaho': 'mountain-west',
    'illinois': 'great-lakes',
    'indiana': 'great-lakes',
    'iowa': 'great-lakes',
    'kansas': 'south-plains',
    'kentucky': 'appalachia',
    'louisiana': 'lower-south',
    'maine': 'northeast',
    'maryland': 'mid-atlantic',
    'massachusetts': 'northeast',
    'michigan': 'great-lakes',
    'minnesota': 'great-lakes',
    'mississippi': 'lower-south',
    'missouri': 'south-plains',
    'montana': 'upper-plains',
    'nebraska': 'south-plains',
    'nevada': 'mountain-west',
    'new-hampshire': 'northeast',
    'new-jersey': 'mid-atlantic',
    'new-mexico': 'mountain-west',
    'new-york': 'northeast',
    'north-carolina': 'southeast-coast',
    'north-dakota': 'upper-plains',
    'ohio': 'great-lakes',
    'oklahoma': 'south-plains',
    'oregon': 'pacific-northwest',
    'pennsylvania': 'mid-atlantic',
    'rhode-island': 'northeast',
    'south-carolina': 'southeast-coast',
    'south-dakota': 'upper-plains',
    'tennessee': 'appalachia',
    'texas': 'south-plains',
    'utah': 'mountain-west',
    'vermont': 'northeast',
    'virginia': 'appalachia',
    'washington': 'pacific-northwest',
    'west-virginia': 'appalachia',
    'wisconsin': 'great-lakes',
    'wyoming': 'upper-plains'
  };

  var STATE_WILDLIFE_LINKS = {
    'alabama': 'https://www.outdooralabama.com',
    'alaska': 'https://www.adfg.alaska.gov',
    'arizona': 'https://www.azgfd.com',
    'arkansas': 'https://www.agfc.com',
    'california': 'https://wildlife.ca.gov',
    'colorado': 'https://cpw.state.co.us',
    'connecticut': 'https://portal.ct.gov/DEEP',
    'delaware': 'https://news.delaware.gov',
    'florida': 'https://myfwc.com',
    'georgia': 'https://georgiawildlife.com',
    'hawaii': 'https://dlnr.hawaii.gov',
    'idaho': 'https://fishandgame.idaho.gov',
    'illinois': 'https://dnr.illinois.gov',
    'indiana': 'https://www.in.gov',
    'iowa': 'https://www.iowadnr.gov',
    'kansas': 'https://ksoutdoors.com',
    'kentucky': 'https://fw.ky.gov',
    'louisiana': 'https://www.wlf.louisiana.gov',
    'maine': 'https://www.maine.gov',
    'maryland': 'https://news.maryland.gov',
    'massachusetts': 'https://www.mass.gov',
    'michigan': 'https://www.michigan.gov',
    'minnesota': 'https://www.dnr.state.mn.us',
    'mississippi': 'https://www.mdwfp.com',
    'missouri': 'https://mdc.mo.gov',
    'montana': 'https://fwp.mt.gov',
    'nebraska': 'https://outdoornebraska.gov',
    'nevada': 'https://www.ndow.org',
    'new-hampshire': 'https://nhfishgame.com',
    'new-jersey': 'https://www.state.nj.us',
    'new-mexico': 'https://wildlife.dgf.nm.gov',
    'new-york': 'https://www.dec.ny.gov',
    'north-carolina': 'https://www.ncwildlife.org',
    'north-dakota': 'https://gf.nd.gov',
    'ohio': 'https://ohiodnr.gov',
    'oklahoma': 'https://www.wildlifedepartment.com',
    'oregon': 'https://myodfw.com',
    'pennsylvania': 'https://www.pgc.pa.gov',
    'rhode-island': 'https://www.dem.ri.gov',
    'south-carolina': 'https://www.dnr.sc.gov',
    'south-dakota': 'https://gfp.sd.gov',
    'tennessee': 'https://www.tn.gov',
    'texas': 'https://tpwd.texas.gov',
    'utah': 'https://wildlife.utah.gov',
    'vermont': 'https://vtfishandwildlife.com',
    'virginia': 'https://dwr.virginia.gov',
    'washington': 'https://wdfw.wa.gov',
    'west-virginia': 'https://www.wvdnr.gov',
    'wisconsin': 'https://dnr.wisconsin.gov',
    'wyoming': 'https://wgfd.wyo.gov'
  };

  var EDITORIAL_KEYWORDS = [
    'ravioli',
    'dumpling',
    'dumplings',
    'hand pie',
    'hand pies',
    'pot pie',
    'tamale',
    'tamales',
    'galette',
    'bierock',
    'bierocks',
    'kolache',
    'kolaches',
    'empanada',
    'empanadas',
    'agnolotti',
    'pierogi'
  ];

  var FARM_RANCH_CATEGORIES = ['beef', 'pork', 'chicken', 'lamb', 'goat'];

  function canUseLocalStorage() {
    if (typeof STORAGE_ENABLED === 'boolean') return STORAGE_ENABLED;
    try {
      var probeKey = '__gg_platform_probe__';
      window.localStorage.setItem(probeKey, '1');
      window.localStorage.removeItem(probeKey);
      STORAGE_ENABLED = true;
    } catch (_error) {
      STORAGE_ENABLED = false;
    }
    return STORAGE_ENABLED;
  }

  function safeParse(value, fallback) {
    if (!value) return fallback;
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function readJsonScript(scope, selector, fallback) {
    var node = scope.querySelector(selector);
    if (!node) return fallback;
    return safeParse(node.textContent, fallback);
  }

  function readStorage(key, fallback) {
    try {
      if (canUseLocalStorage()) {
        var localValue = window.localStorage.getItem(key);
        if (localValue != null) return safeParse(localValue, fallback);
      }
    } catch (error) {
    }
    return Object.prototype.hasOwnProperty.call(MEMORY_STORAGE, key)
      ? safeParse(MEMORY_STORAGE[key], fallback)
      : fallback;
  }

  function writeStorage(key, value) {
    MEMORY_STORAGE[key] = JSON.stringify(value);
    try {
      if (canUseLocalStorage()) {
        window.localStorage.setItem(key, MEMORY_STORAGE[key]);
      }
    } catch (error) {
      return;
    }
  }

  async function fetchWithTimeout(url, options) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeoutId = null;
    var nextOptions = options ? Object.assign({}, options) : {};

    if (controller) {
      nextOptions.signal = controller.signal;
      timeoutId = window.setTimeout(function () {
        controller.abort();
      }, REQUEST_TIMEOUT_MS);
    }

    try {
      return await fetch(url, nextOptions);
    } finally {
      if (timeoutId) window.clearTimeout(timeoutId);
    }
  }

  async function readJsonResponse(response) {
    if (!response) return null;
    var text = await response.text();
    return text ? safeParse(stripBom(text), null) : null;
  }

  function toArray(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (value == null || value === '') return [];
    return [value];
  }

  function unique(values) {
    return Array.from(new Set(toArray(values)));
  }

  function toNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? (fallback == null ? 0 : fallback) : parsed;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function slugToTitle(slug) {
    return String(slug || '')
      .replace(/-/g, ' ')
      .replace(/\b\w/g, function (character) {
        return character.toUpperCase();
      });
  }

  function findBySlug(collection, slug) {
    return (collection || []).find(function (entry) {
      return entry && entry.slug === slug;
    });
  }

  function normalizeHarvest(harvest) {
    if (!harvest) return null;

    var normalizedCuts = [];
    if (Array.isArray(harvest.cuts) && harvest.cuts.length) {
      normalizedCuts = harvest.cuts
        .map(function (item) {
          if (!item) return null;
          if (typeof item === 'string') {
            return { cut: item, quantity: '' };
          }
          return {
            cut: item.cut || '',
            quantity: item.quantity || ''
          };
        })
        .filter(function (item) {
          return item && item.cut;
        });
    } else if (harvest.cut) {
      normalizedCuts = [{ cut: harvest.cut, quantity: harvest.quantity || '' }];
    }

    return {
      id: harvest.id || harvest.harvest_id || '',
      harvest_type: harvest.harvest_type || '',
      species: harvest.species || '',
      cut: harvest.cut || (normalizedCuts[0] ? normalizedCuts[0].cut : ''),
      cuts: normalizedCuts,
      harvest_state: harvest.harvest_state || '',
      date: harvest.date || '',
      source: harvest.source || '',
      location_nickname: harvest.location_nickname || '',
      quantity_kept: harvest.quantity_kept || '',
      method_label: harvest.method_label || '',
      weather_notes: harvest.weather_notes || '',
      conditions_notes: harvest.conditions_notes || '',
      companions: harvest.companions || '',
      processing_notes: harvest.processing_notes || '',
      notes: harvest.notes || '',
      summary: harvest.summary || '',
      quantity: harvest.quantity || '',
      journal_title: harvest.journal_title || '',
      journal_entry: harvest.journal_entry || '',
      journal_privacy_status: harvest.journal_privacy_status || 'private',
      journal_entry_id: harvest.journal_entry_id || ''
    };
  }

  function buildClientId(prefix) {
    return prefix + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
  }

  function normalizeRecipe(recipe) {
    if (!recipe) return null;
    return {
      id: recipe.id || recipe.recipe_id || '',
      title: recipe.title || '',
      short_description: recipe.short_description || '',
      ingredients: recipe.ingredients || recipe.ingredients_markdown || '',
      instructions: recipe.instructions || recipe.instructions_markdown || '',
      prep_time_minutes: recipe.prep_time_minutes || '',
      cook_time_minutes: recipe.cook_time_minutes || '',
      servings: recipe.servings || '',
      species_category: recipe.species_category || '',
      species_slug: recipe.species_slug || '',
      garden_item_slugs: unique(recipe.garden_item_slugs || recipe.garden_items || []),
      season: recipe.season || '',
      difficulty: recipe.difficulty || '',
      story: recipe.story || recipe.story_context || '',
      image_url: recipe.image_url || '',
      privacy_status: recipe.privacy_status || 'private',
      community_status: recipe.community_status || 'private',
      linked_harvest_log_id: recipe.linked_harvest_log_id || '',
      type_tags: unique(recipe.type_tags || recipe.recipe_types || [])
    };
  }

  function normalizeJournalEntry(entry) {
    if (!entry) return null;
    return {
      id: entry.id || entry.entry_id || '',
      title: entry.title || '',
      entry_date: entry.entry_date || entry.date || '',
      body: entry.body || entry.body_markdown || entry.entry || '',
      privacy_status: entry.privacy_status || 'private',
      linked_harvest_log_id: entry.linked_harvest_log_id || '',
      entry_type: entry.entry_type || 'harvest_journal'
    };
  }

  function normalizeCookbookProject(project) {
    if (!project) return null;
    return {
      id: project.id || project.project_id || '',
      title: project.title || '',
      subtitle: project.subtitle || '',
      dedication: project.dedication || '',
      book_type: project.book_type || 'family_field_to_table',
      status: project.status || 'draft',
      source_counts: project.source_counts || {}
    };
  }

  function getSelectedCuts(harvest) {
    var normalized = normalizeHarvest(harvest);
    if (!normalized) return [];
    return normalized.cuts.length ? normalized.cuts : (normalized.cut ? [{ cut: normalized.cut, quantity: normalized.quantity || '' }] : []);
  }

  function mergeProfile(initialProfile) {
    var storedProfile = readStorage(STORAGE_KEYS.profile, {});
    return {
      state: storedProfile.state || initialProfile.state || '',
      garden_items: unique(storedProfile.garden_items && storedProfile.garden_items.length ? storedProfile.garden_items : initialProfile.garden_items || [])
    };
  }

  function getLatestHarvest(initialLatestHarvest) {
    var stored = readStorage(STORAGE_KEYS.latestHarvest, null);
    return normalizeHarvest(stored || initialLatestHarvest || null);
  }

  function getHarvestLogs() {
    return readStorage(STORAGE_KEYS.harvestLogs, []).map(normalizeHarvest).filter(Boolean);
  }

  function getHarvestRecommendationsUrl(index) {
    if (typeof index === 'number' && index >= 0) {
      return '/pages/platform-recommendations?harvest=' + index;
    }
    return '/pages/platform-recommendations';
  }

  function getActiveHarvest(initialLatestHarvest) {
    var latestHarvest = getLatestHarvest(initialLatestHarvest);

    try {
      var params = new URLSearchParams(window.location.search || '');
      var requested = params.get('harvest');
      if (requested == null || requested === '') return latestHarvest;

      var index = parseInt(requested, 10);
      if (isNaN(index) || index < 0) return latestHarvest;

      var logs = getHarvestLogs();
      return logs[index] || latestHarvest;
    } catch (error) {
      return latestHarvest;
    }
  }

  function hasRequestedHarvestOverride() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return params.get('harvest') != null && params.get('harvest') !== '';
    } catch (error) {
      return false;
    }
  }

  function saveProfileLocal(profile) {
    var normalizedProfile = {
      state: profile.state || '',
      garden_items: unique(profile.garden_items || [])
    };
    writeStorage(STORAGE_KEYS.profile, normalizedProfile);
    patchCachedAccountState({ profile: normalizedProfile });
  }

  function saveHarvestLocal(harvest) {
    var normalized = normalizeHarvest(harvest);
    if (!normalized.id) {
      normalized.id = buildClientId('harvest');
    }
    writeStorage(STORAGE_KEYS.latestHarvest, normalized);

    var logs = getHarvestLogs();
    logs = logs.filter(function (entry) {
      return entry.id !== normalized.id;
    });
    logs.unshift(normalized);
    logs = logs.slice(0, 50);
    writeStorage(STORAGE_KEYS.harvestLogs, logs);
    patchCachedAccountState({
      latestHarvest: normalized,
      harvestLogs: logs
    });

    if (normalized.journal_entry) {
      upsertJournalEntryLocal({
        id: normalized.journal_entry_id || buildClientId('journal'),
        title: normalized.journal_title || (slugToTitle(normalized.species) + ' field notes'),
        entry_date: normalized.date || '',
        body: normalized.journal_entry,
        privacy_status: normalized.journal_privacy_status || 'private',
        linked_harvest_log_id: normalized.id,
        entry_type: 'harvest_journal'
      });
    }
  }

  function getFavoriteRecipes() {
    return readStorage(STORAGE_KEYS.favoriteRecipes, []).map(function (item) {
      if (typeof item === 'string') return { slug: item, title: slugToTitle(item), url: '' };
      return {
        slug: item && item.slug || '',
        title: item && item.title || slugToTitle(item && item.slug || ''),
        url: item && item.url || ''
      };
    }).filter(function (item) {
      return item.slug;
    });
  }

  function getSavedRecipes() {
    return readStorage(STORAGE_KEYS.recipes, []).map(normalizeRecipe).filter(Boolean);
  }

  function saveRecipesLocal(recipes) {
    var normalizedRecipes = (recipes || []).map(normalizeRecipe).filter(Boolean);
    writeStorage(STORAGE_KEYS.recipes, normalizedRecipes);
    patchCachedAccountState({ recipes: normalizedRecipes });
  }

  function upsertRecipeLocal(recipe) {
    var recipes = getSavedRecipes().filter(function (entry) {
      return entry.id !== recipe.id;
    });
    recipes.unshift(normalizeRecipe(recipe));
    saveRecipesLocal(recipes.slice(0, 200));
    return recipes;
  }

  function getJournalEntries() {
    return readStorage(STORAGE_KEYS.journalEntries, []).map(normalizeJournalEntry).filter(Boolean);
  }

  function saveJournalEntriesLocal(entries) {
    var normalizedEntries = (entries || []).map(normalizeJournalEntry).filter(Boolean);
    writeStorage(STORAGE_KEYS.journalEntries, normalizedEntries);
    patchCachedAccountState({ journalEntries: normalizedEntries });
  }

  function upsertJournalEntryLocal(entry) {
    var entries = getJournalEntries().filter(function (item) {
      return item.id !== entry.id;
    });
    entries.unshift(normalizeJournalEntry(entry));
    saveJournalEntriesLocal(entries.slice(0, 200));
    return entries;
  }

  function getCookbookProjects() {
    return readStorage(STORAGE_KEYS.cookbookProjects, []).map(normalizeCookbookProject).filter(Boolean);
  }

  function saveCookbookProjectsLocal(projects) {
    var normalizedProjects = (projects || []).map(normalizeCookbookProject).filter(Boolean);
    writeStorage(STORAGE_KEYS.cookbookProjects, normalizedProjects);
    patchCachedAccountState({ cookbookProjects: normalizedProjects });
  }

  function upsertCookbookProjectLocal(project) {
    var projects = getCookbookProjects().filter(function (item) {
      return item.id !== project.id;
    });
    projects.unshift(normalizeCookbookProject(project));
    saveCookbookProjectsLocal(projects.slice(0, 50));
    return projects;
  }

  function buildLocalAccountState(initialProfile) {
    return {
      profile: mergeProfile(initialProfile || {}),
      latestHarvest: getLatestHarvest(initialProfile && initialProfile.latest_harvest),
      harvestLogs: getHarvestLogs(),
      favoriteRecipes: getFavoriteRecipes(),
      recipes: getSavedRecipes(),
      journalEntries: getJournalEntries(),
      cookbookProjects: getCookbookProjects(),
      syncStatus: 'local',
      syncError: ''
    };
  }

  function setCachedAccountState(nextState) {
    accountStateCache = {
      profile: mergeProfile(nextState && nextState.profile ? nextState.profile : {}),
      latestHarvest: normalizeHarvest(nextState && nextState.latestHarvest),
      harvestLogs: (nextState && nextState.harvestLogs || []).map(normalizeHarvest).filter(Boolean),
      favoriteRecipes: nextState && nextState.favoriteRecipes || [],
      recipes: (nextState && nextState.recipes || []).map(normalizeRecipe).filter(Boolean),
      journalEntries: (nextState && nextState.journalEntries || []).map(normalizeJournalEntry).filter(Boolean),
      cookbookProjects: (nextState && nextState.cookbookProjects || []).map(normalizeCookbookProject).filter(Boolean),
      syncStatus: nextState && nextState.syncStatus || 'local',
      syncError: nextState && nextState.syncError || ''
    };
    return accountStateCache;
  }

  function patchCachedAccountState(patch) {
    var base = accountStateCache || buildLocalAccountState({});
    return setCachedAccountState({
      profile: patch && patch.profile !== undefined ? patch.profile : base.profile,
      latestHarvest: patch && patch.latestHarvest !== undefined ? patch.latestHarvest : base.latestHarvest,
      harvestLogs: patch && patch.harvestLogs !== undefined ? patch.harvestLogs : base.harvestLogs,
      favoriteRecipes: patch && patch.favoriteRecipes !== undefined ? patch.favoriteRecipes : base.favoriteRecipes,
      recipes: patch && patch.recipes !== undefined ? patch.recipes : base.recipes,
      journalEntries: patch && patch.journalEntries !== undefined ? patch.journalEntries : base.journalEntries,
      cookbookProjects: patch && patch.cookbookProjects !== undefined ? patch.cookbookProjects : base.cookbookProjects,
      syncStatus: patch && patch.syncStatus !== undefined ? patch.syncStatus : base.syncStatus,
      syncError: patch && patch.syncError !== undefined ? patch.syncError : base.syncError
    });
  }

  function isFavoriteRecipe(slug) {
    return getFavoriteRecipes().some(function (item) { return item.slug === slug; });
  }

  function toggleFavoriteRecipe(recipe) {
    var favorites = getFavoriteRecipes();
    var slug = recipe && recipe.slug || '';
    if (!slug) return favorites;
    var wasFavorite = favorites.some(function (item) { return item.slug === slug; });
    if (favorites.some(function (item) { return item.slug === slug; })) {
      favorites = favorites.filter(function (item) { return item.slug !== slug; });
    } else {
      favorites.unshift({
        slug: slug,
        title: recipe.title || slugToTitle(slug),
        url: recipe.url || ''
      });
    }
    writeStorage(STORAGE_KEYS.favoriteRecipes, favorites.slice(0, 100));
    patchCachedAccountState({ favoriteRecipes: favorites.slice(0, 100) });
    document.dispatchEvent(new CustomEvent('gg:favorites-updated', {
      bubbles: true,
      detail: { favorites: favorites }
    }));
    tryEndpoint('/apps/garden-and-game/favorites', {
      favorite_recipes: favorites
    });
    trackEvent(wasFavorite ? 'favorite_recipe_removed' : 'favorite_recipe_saved', {
      recipeSlug: slug,
      recipeTitle: recipe && recipe.title || slugToTitle(slug)
    });
    return favorites;
  }

  function readRecipeIndexManifest(root) {
    return readJsonScript(root, '[data-ftt-recipe-index-manifest]', {});
  }

  function stripBom(text) {
    return String(text || '').replace(/^\uFEFF/, '');
  }

  function normalizeRecipeRecord(recipe) {
    if (!recipe) return null;
    return {
      slug: recipe.slug || '',
      url: recipe.url || '',
      title: recipe.title || '',
      short_description: recipe.short_description || '',
      long_description: recipe.long_description || '',
      species_slugs: toArray(recipe.species_slugs).filter(Boolean),
      cut_slugs: toArray(recipe.cut_slugs).filter(Boolean),
      required_garden_item_slugs: toArray(recipe.required_garden_item_slugs).filter(Boolean),
      optional_garden_item_slugs: toArray(recipe.optional_garden_item_slugs).filter(Boolean),
      state_slugs: toArray(recipe.state_slugs).filter(Boolean),
      region_tags: toArray(recipe.region_tags).filter(Boolean),
      cooking_method: recipe.cooking_method || '',
      prep_time_minutes: recipe.prep_time_minutes || '',
      cook_time_minutes: recipe.cook_time_minutes || '',
      servings: recipe.servings || '',
      match_priority_score: recipe.match_priority_score || 0,
      style_tags: toArray(recipe.style_tags).filter(Boolean),
      editorial_priority: !!recipe.editorial_priority
    };
  }

  async function loadRecipesForSpecies(root, speciesSlug) {
    if (!speciesSlug) return [];
    if (recipeIndexCache[speciesSlug]) return recipeIndexCache[speciesSlug];

    var manifest = readRecipeIndexManifest(root);
    var url = manifest && manifest[speciesSlug];
    if (!url) {
      recipeIndexCache[speciesSlug] = [];
      return [];
    }

    try {
      var response = await fetchWithTimeout(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Recipe index request failed');
      var rawText = await response.text();
      var data = safeParse(stripBom(rawText), []);
      recipeIndexCache[speciesSlug] = Array.isArray(data) ? data.map(normalizeRecipeRecord).filter(Boolean) : [];
      return recipeIndexCache[speciesSlug];
    } catch (error) {
      recipeIndexCache[speciesSlug] = [];
      return [];
    }
  }

  function buildGardenLookup(items) {
    var lookup = {};
    (items || []).forEach(function (item) {
      if (!item || !item.slug) return;
      lookup[item.slug] = item;
    });
    return lookup;
  }

  function buildStateLookup(items) {
    var lookup = {};
    (items || []).forEach(function (item) {
      if (!item || !item.slug) return;
      lookup[item.slug] = item;
    });
    return lookup;
  }

  function formatGardenItems(slugs, gardenLookup) {
    return unique(slugs).map(function (slug) {
      var item = gardenLookup[slug];
      return item ? item.title : slugToTitle(slug);
    });
  }

  function formatStateTitle(slug, stateLookup) {
    if (!slug) return '';
    var state = stateLookup && stateLookup[slug];
    return state ? state.title : slugToTitle(slug);
  }

  function stripStatePrefix(title, stateSlug, stateLookup) {
    var text = String(title || '');
    var stateTitle = formatStateTitle(stateSlug, stateLookup);
    if (!stateTitle) return text;
    var prefix = stateTitle + ' ';
    return text.indexOf(prefix) === 0 ? text.slice(prefix.length) : text;
  }

  function getRecipeDisplayTitle(recipe, stateLookup) {
    var stateSlug = toArray(recipe && recipe.state_slugs)[0] || '';
    return stripStatePrefix(recipe && recipe.title, stateSlug, stateLookup);
  }

  function getRegionForStateSlug(stateSlug) {
    return STATE_REGION_MAP[stateSlug || ''] || '';
  }

  function isFarmHarvestType(harvestType) {
    return harvestType === 'farm-raised' || harvestType === 'ranch-raised';
  }

  function getWildlifeAgencyUrl(stateSlug) {
    return STATE_WILDLIFE_LINKS[stateSlug || ''] || '';
  }

  function getEditorialRecipeBoost(recipe) {
    if (!recipe) return 0;

    var title = String(recipe.title || '').toLowerCase();
    var styleTags = toArray(recipe.style_tags).map(function (tag) {
      return String(tag || '').toLowerCase();
    });
    var boost = recipe.editorial_priority ? 50 : 0;

    if (styleTags.indexOf('editorial') >= 0) {
      boost += 15;
    }

    if (EDITORIAL_KEYWORDS.some(function (keyword) {
      return title.indexOf(keyword) >= 0;
    })) {
      boost += 25;
    }

    if (boost === 0 && /\bwith\s+[a-z0-9' -]+\s+and\s+[a-z0-9' -]+$/i.test(title)) {
      boost -= 10;
    }

    return boost;
  }

  function computeRecipeMatches(profile, harvest, recipes) {
    if (!harvest || !harvest.species) return [];

    var gardenItems = unique(profile.garden_items || []);
    var state = profile.state || '';
    var selectedCuts = getSelectedCuts(harvest);
    var selectedCutSlugs = unique(selectedCuts.map(function (item) { return item.cut; }));

    var matches = (recipes || []).map(function (recipe) {
      var speciesMatches = toArray(recipe.species_slugs).indexOf(harvest.species) >= 0;
      var recipeCuts = toArray(recipe.cut_slugs);
      var matchedCut = selectedCutSlugs.find(function (cutSlug) {
        return recipeCuts.indexOf(cutSlug) >= 0;
      }) || '';
      var cutMatches = !selectedCutSlugs.length || !!matchedCut;
      var stateTags = toArray(recipe.state_slugs);
      var stateMatches = !state || stateTags.length === 0 || stateTags.indexOf(state) >= 0;
      var requiredGardenMatches = toArray(recipe.required_garden_item_slugs).filter(function (slug) {
        return gardenItems.indexOf(slug) >= 0;
      });
      var optionalGardenMatches = toArray(recipe.optional_garden_item_slugs).filter(function (slug) {
        return gardenItems.indexOf(slug) >= 0;
      });
      var gardenMatchCount = requiredGardenMatches.length + optionalGardenMatches.length;

      if (!speciesMatches) {
        return null;
      }

      var tier = 4;
      if (cutMatches && gardenMatchCount >= 2) {
        tier = 1;
      } else if (cutMatches && gardenMatchCount >= 1) {
        tier = 2;
      } else if (cutMatches) {
        tier = 3;
      }

      var score = (5 - tier) * 100
        + gardenMatchCount * 10
        + (stateMatches ? 5 : 0)
        + Math.min(toNumber(recipe.match_priority_score, 0), 140)
        + getEditorialRecipeBoost(recipe);

      return {
        recipe: recipe,
        tier: tier,
        score: score,
        stateMatches: stateMatches,
        gardenMatches: unique(requiredGardenMatches.concat(optionalGardenMatches)),
        matchedCut: matchedCut
      };
    }).filter(Boolean).sort(function (left, right) {
      return right.score - left.score;
    });

    var inStateMatches = matches.filter(function (match) {
      return match.stateMatches;
    });

    return inStateMatches.length ? inStateMatches : matches;
  }

  function computeTechniqueMatches(harvest, techniques) {
    if (!harvest || !harvest.species) return [];

    var selectedCuts = getSelectedCuts(harvest);
    var selectedCutSlugs = unique(selectedCuts.map(function (item) { return item.cut; }));

    return (techniques || []).map(function (technique) {
      var speciesMatches = toArray(technique.species_slugs).indexOf(harvest.species) >= 0;
      var techniqueCuts = toArray(technique.cut_slugs);
      var matchedCut = selectedCutSlugs.find(function (cutSlug) {
        return techniqueCuts.indexOf(cutSlug) >= 0;
      }) || '';
      var cutMatches = !selectedCutSlugs.length || !!matchedCut;

      if (!speciesMatches) {
        return null;
      }

      return {
        technique: technique,
        score: (cutMatches ? 20 : 10) + toArray(technique.method_tags).length,
        matchedCut: matchedCut
      };
    }).filter(Boolean).sort(function (left, right) {
      return right.score - left.score;
    });
  }

  function tierLabel(tier) {
    if (tier === 1) return 'Strongest match';
    if (tier === 2) return 'Good match';
    if (tier === 3) return 'Cut match';
    return 'Species fallback';
  }

  function formatTime(recipe) {
    var parts = [];
    if (recipe.prep_time_minutes) parts.push(recipe.prep_time_minutes + ' min prep');
    if (recipe.cook_time_minutes) parts.push(recipe.cook_time_minutes + ' min cook');
    if (recipe.cooking_method) parts.push(recipe.cooking_method);
    return parts.join(' Ã¢â‚¬Â¢ ');
  }

  function renderOpenLink(url, label) {
    if (!url) return '';
    return '<a class="text-link" href="' + escapeHtml(url) + '">' + escapeHtml(label || 'Open item') + ' &rarr;</a>';
  }

  function renderFavoriteButton(recipe, titleOverride) {
    if (!recipe || !recipe.slug) return '';
    var saved = isFavoriteRecipe(recipe.slug);
    return '<button class="text-link" type="button" data-ftt-favorite-recipe="' + escapeHtml(recipe.slug) + '" data-ftt-favorite-title="' + escapeHtml(titleOverride || recipe.title || '') + '" data-ftt-favorite-url="' + escapeHtml(recipe.url || '') + '">' + (saved ? 'Saved to profile' : 'Save recipe') + '</button>';
  }

  function bindFavoriteButtons(scope) {
    Array.prototype.slice.call(scope.querySelectorAll('[data-ftt-favorite-recipe]')).forEach(function (button) {
      var slug = button.getAttribute('data-ftt-favorite-recipe');
      button.textContent = isFavoriteRecipe(slug) ? 'Saved to profile' : 'Save recipe';
      if (button.getAttribute('data-ftt-favorite-bound') === 'true') {
        return;
      }
      button.setAttribute('data-ftt-favorite-bound', 'true');
      button.addEventListener('click', function () {
        toggleFavoriteRecipe({
          slug: slug,
          title: button.getAttribute('data-ftt-favorite-title') || '',
          url: button.getAttribute('data-ftt-favorite-url') || ''
        });
        button.textContent = isFavoriteRecipe(slug) ? 'Saved to profile' : 'Save recipe';
      });
    });
  }

  function formatCutSummary(cuts) {
    return (cuts || []).map(function (item) {
      if (!item || !item.cut) return '';
      return slugToTitle(item.cut) + (item.quantity ? ' (' + item.quantity + ')' : '');
    }).filter(Boolean).join(', ');
  }

  function formatHarvestLabel(harvest, stateLookup) {
    var normalized = normalizeHarvest(harvest);
    if (!normalized) return '';
    var parts = [];
    if (normalized.date) parts.push(normalized.date);
    if (normalized.species) parts.push(slugToTitle(normalized.species));
    if (normalized.harvest_state) parts.push(formatStateTitle(normalized.harvest_state, stateLookup));
    var cutSummary = formatCutSummary(getSelectedCuts(normalized));
    if (cutSummary) parts.push(cutSummary);
    return parts.join(' | ');
  }

  function renderMessage(target, message, className) {
    if (!target) return;
    target.innerHTML = '<p class="' + escapeHtml(className || 'platform-empty-copy') + '">' + escapeHtml(message || '') + '</p>';
  }

  function trackEvent(eventName, payload) {
    if (!eventName || !window.GGAnalytics || typeof window.GGAnalytics.track !== 'function') {
      return;
    }
    window.GGAnalytics.track(eventName, payload || {});
  }

  function setHidden(target, shouldHide) {
    if (!target) return;
    target.hidden = !!shouldHide;
  }

  function renderProfileLoadingState(root) {
    renderMessage(root.querySelector('[data-ftt-profile-harvests]'), 'Loading harvest history...');
    renderMessage(root.querySelector('[data-ftt-profile-favorites]'), 'Loading saved recipes...');
    renderMessage(root.querySelector('[data-ftt-profile-recipes]'), 'Loading personal recipes...');
    renderMessage(root.querySelector('[data-ftt-profile-journals]'), 'Loading field notes...');
    renderMessage(root.querySelector('[data-ftt-profile-cookbooks]'), 'Loading cookbook drafts...');
  }

  function formatTime(recipe) {
    var parts = [];
    if (recipe && recipe.prep_time_minutes) parts.push(recipe.prep_time_minutes + ' min prep');
    if (recipe && recipe.cook_time_minutes) parts.push(recipe.cook_time_minutes + ' min cook');
    if (recipe && recipe.cooking_method) parts.push(recipe.cooking_method);
    return parts.join(' | ');
  }

  function ensureRootAccountState(root) {
    if (!root.__ggAccountState) {
      root.__ggAccountState = {
        profile: mergeProfile({}),
        latestHarvest: getLatestHarvest(null),
        harvestLogs: getHarvestLogs(),
        favoriteRecipes: getFavoriteRecipes(),
        recipes: getSavedRecipes(),
        journalEntries: getJournalEntries(),
        cookbookProjects: getCookbookProjects(),
        syncStatus: 'local',
        syncError: ''
      };
    }
    return root.__ggAccountState;
  }

  function setRootAccountState(root, nextState) {
    root.__ggAccountState = {
      profile: nextState.profile || mergeProfile({}),
      latestHarvest: nextState.latestHarvest || null,
      harvestLogs: nextState.harvestLogs || [],
      favoriteRecipes: nextState.favoriteRecipes || [],
      recipes: nextState.recipes || [],
      journalEntries: nextState.journalEntries || [],
      cookbookProjects: nextState.cookbookProjects || [],
      syncStatus: nextState.syncStatus || 'local',
      syncError: nextState.syncError || ''
    };
    return root.__ggAccountState;
  }

  function groupMatchesByCut(matches) {
    var grouped = {};
    (matches || []).forEach(function (match) {
      var key = match.matchedCut || 'general';
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(match);
    });
    return grouped;
  }

  async function tryEndpoint(endpoint, payload) {
    if (!endpoint) return false;
    try {
      var response = await fetchWithTimeout(endpoint, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      if (!response.ok) return false;
      return await readJsonResponse(response) || { ok: true };
    } catch (error) {
      return false;
    }
  }

  async function loadAccountState(initialProfile) {
    if (accountStateCache) return accountStateCache;
    if (accountStateRequest) return accountStateRequest;

    var localState = buildLocalAccountState(initialProfile);

    accountStateRequest = (async function () {
      try {
        var response = await fetchWithTimeout('/apps/garden-and-game/profile-state', {
          credentials: 'include'
        });
        if (!response.ok) throw new Error('Account state request failed');

        var data = await readJsonResponse(response) || {};
        var remoteProfile = data && data.profile ? data.profile : {};
        var remoteHarvestLogs = Array.isArray(data && data.harvest_logs) ? data.harvest_logs.map(normalizeHarvest).filter(Boolean) : [];
        var remoteFavorites = Array.isArray(data && data.favorite_recipes) ? data.favorite_recipes : [];
        var remoteRecipes = Array.isArray(data && data.recipes) ? data.recipes.map(normalizeRecipe).filter(Boolean) : [];
        var remoteJournalEntries = Array.isArray(data && data.journal_entries) ? data.journal_entries.map(normalizeJournalEntry).filter(Boolean) : [];
        var remoteCookbookProjects = Array.isArray(data && data.cookbook_projects) ? data.cookbook_projects.map(normalizeCookbookProject).filter(Boolean) : [];

        var mergedProfile = {
          state: remoteProfile.state || localState.profile.state || '',
          garden_items: unique((remoteProfile.garden_items && remoteProfile.garden_items.length ? remoteProfile.garden_items : localState.profile.garden_items) || [])
        };
        var resolvedHarvestLogs = remoteHarvestLogs.length ? remoteHarvestLogs : localState.harvestLogs;
        var resolvedFavorites = remoteFavorites.length ? remoteFavorites : localState.favoriteRecipes;
        var resolvedRecipes = remoteRecipes.length ? remoteRecipes : localState.recipes;
        var resolvedJournalEntries = remoteJournalEntries.length ? remoteJournalEntries : localState.journalEntries;
        var resolvedCookbookProjects = remoteCookbookProjects.length ? remoteCookbookProjects : localState.cookbookProjects;

        saveProfileLocal(mergedProfile);
        writeStorage(STORAGE_KEYS.harvestLogs, resolvedHarvestLogs);
        writeStorage(STORAGE_KEYS.latestHarvest, resolvedHarvestLogs[0] || localState.latestHarvest || null);
        writeStorage(STORAGE_KEYS.favoriteRecipes, resolvedFavorites);
        saveRecipesLocal(resolvedRecipes);
        saveJournalEntriesLocal(resolvedJournalEntries);
        saveCookbookProjectsLocal(resolvedCookbookProjects);

        return setCachedAccountState({
          profile: mergedProfile,
          latestHarvest: resolvedHarvestLogs[0] || localState.latestHarvest || null,
          harvestLogs: resolvedHarvestLogs,
          favoriteRecipes: resolvedFavorites,
          recipes: resolvedRecipes,
          journalEntries: resolvedJournalEntries,
          cookbookProjects: resolvedCookbookProjects,
          syncStatus: 'remote',
          syncError: ''
        });
      } catch (error) {
        return setCachedAccountState({
          profile: localState.profile,
          latestHarvest: localState.latestHarvest,
          harvestLogs: localState.harvestLogs,
          favoriteRecipes: localState.favoriteRecipes,
          recipes: localState.recipes,
          journalEntries: localState.journalEntries,
          cookbookProjects: localState.cookbookProjects,
          syncStatus: 'local',
          syncError: error && error.message ? error.message : 'Account data unavailable'
        });
      } finally {
        accountStateRequest = null;
      }
    })();

    return accountStateRequest;
  }

  function renderGardenTiles(scope, selectedState, statesData) {
    var tiles = Array.prototype.slice.call(scope.querySelectorAll('[data-ftt-garden-tile]'));
    var hintTarget = scope.querySelector('[data-ftt-state-hint]');
    var stateRecord = findBySlug(statesData || [], selectedState);
    var recommendedSlugs = unique(stateRecord && stateRecord.recommended_garden_item_slugs || []);

    tiles.forEach(function (tile) {
      var checkbox = tile.querySelector('input[name="garden_items[]"]');
      var badge = tile.querySelector('[data-ftt-recommended-badge]');
      var slug = tile.getAttribute('data-item-slug');
      var isSelected = !!(checkbox && checkbox.checked);
      var isRecommended = !!selectedState && recommendedSlugs.indexOf(slug) >= 0;

      tile.classList.toggle('is-selected', isSelected);
      tile.classList.toggle('is-recommended', isRecommended);
      if (badge) badge.hidden = !isRecommended;
    });

    if (hintTarget) {
      hintTarget.textContent = selectedState
        ? 'Recommended items for ' + slugToTitle(selectedState) + ' are highlighted below.'
        : 'Select a state to surface garden items that fit your region more closely.';
    }
  }

  function updateGardenCount(scope) {
    var countTarget = scope.querySelector('[data-ftt-garden-count]');
    if (!countTarget) return;
    countTarget.textContent = scope.querySelectorAll('input[name="garden_items[]"]:checked').length;
  }

  function initProfileForm(form, redirectUrl) {
    var endpoint = form.getAttribute('data-endpoint');
    var stateSelect = form.querySelector('[data-ftt-state-select]');
    var statusTarget = form.querySelector('[data-ftt-onboarding-status]');
    var root = form.closest('[data-ftt-root]');
    var statesData = readJsonScript(root, '[data-ftt-states-json]', []);
    var initialProfile = {
      state: form.getAttribute('data-initial-state') || '',
      garden_items: safeParse(form.getAttribute('data-initial-garden'), [])
    };
    var profile = mergeProfile(initialProfile);

    if (stateSelect && profile.state) {
      stateSelect.value = profile.state;
    }

    Array.prototype.slice.call(form.querySelectorAll('input[name="garden_items[]"]')).forEach(function (input) {
      input.checked = profile.garden_items.indexOf(input.value) >= 0;
      input.addEventListener('change', function () {
        updateGardenCount(form);
        renderGardenTiles(form, stateSelect ? stateSelect.value : '', statesData);
      });
    });

    if (stateSelect) {
      stateSelect.addEventListener('change', function () {
        renderGardenTiles(form, stateSelect.value, statesData);
      });
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      var payload = {
        state: stateSelect ? stateSelect.value : '',
        garden_items: Array.prototype.slice.call(form.querySelectorAll('input[name="garden_items[]"]:checked')).map(function (input) {
          return input.value;
        })
      };

      if (!payload.state) {
        if (statusTarget) statusTarget.textContent = 'Choose your state before continuing.';
        return;
      }

      saveProfileLocal(payload);
      if (root && root.getAttribute('data-ftt-root') === 'profile') {
        var accountState = ensureRootAccountState(root);
        accountState.profile = mergeProfile(payload);
      }

      if (statusTarget) statusTarget.textContent = 'Saving your season...';
      var synced = await tryEndpoint(endpoint, payload);
      if (synced && synced.profile && root && root.getAttribute('data-ftt-root') === 'profile') {
        ensureRootAccountState(root).profile = mergeProfile(synced.profile);
      }
      if (statusTarget) {
        statusTarget.textContent = synced
          ? (redirectUrl ? 'Saved. Taking you to the next step...' : 'Profile saved to your account.')
          : 'Saved on this device. Full account sync will start working once the app endpoint is connected.';
      }
      trackEvent('profile_save', {
        state: payload.state,
        gardenCount: payload.garden_items.length,
        syncStatus: synced ? 'remote' : 'local'
      });

      if (redirectUrl) {
        window.setTimeout(function () {
          window.location.href = redirectUrl;
        }, 350);
      }
    });

    updateGardenCount(form);
    renderGardenTiles(form, stateSelect ? stateSelect.value : '', statesData);
  }

  function initHarvestForm(form) {
    var endpoint = form.getAttribute('data-endpoint');
    var harvestTypeSelect = form.querySelector('[name="harvest_type"]');
    var speciesSelect = form.querySelector('[data-ftt-harvest-species]');
    var harvestStateSelect = form.querySelector('[data-ftt-harvest-state]');
    var speciesHint = form.querySelector('[data-ftt-species-hint]');
    var statusTarget = form.querySelector('[data-ftt-harvest-status]');
    var root = form.closest('[data-ftt-root]');
    var cutData = readJsonScript(root, '[data-ftt-cuts-json]', []);
    var stateData = readJsonScript(root, '[data-ftt-harvest-states-json]', []);
    var speciesData = readJsonScript(root, '[data-ftt-harvest-species-json]', []);
    var harvestStateLookup = buildStateLookup(stateData);
    var cutGrid = form.querySelector('[data-ftt-cut-grid]');
    var selectedCutsTarget = form.querySelector('[data-ftt-selected-cuts]');
    var selectedCutsEmpty = form.querySelector('[data-ftt-selected-cuts-empty]');
    var cutHint = form.querySelector('[data-ftt-cut-hint]');
    var selectedCuts = [];

    if (harvestStateSelect && form.getAttribute('data-initial-harvest-state')) {
      harvestStateSelect.value = form.getAttribute('data-initial-harvest-state');
    }

    function filterSpeciesOptions() {
      if (!speciesSelect) return;
      var harvestState = harvestStateSelect ? harvestStateSelect.value : '';
      var harvestType = harvestTypeSelect ? harvestTypeSelect.value : 'hunt';
      var farmRaisedFlow = isFarmHarvestType(harvestType);
      var selectedStateRecord = findBySlug(stateData, harvestState);
      var allowedSpecies = unique(selectedStateRecord && selectedStateRecord.likely_species_slugs || []);
      var region = getRegionForStateSlug(harvestState);

      Array.prototype.slice.call(speciesSelect.options).forEach(function (option, index) {
        if (index === 0) return;
        var speciesRecord = findBySlug(speciesData, option.value);
        var category = String(speciesRecord && speciesRecord.category || '').toLowerCase();
        var farmSpecies = FARM_RANCH_CATEGORIES.indexOf(category) >= 0;
        var regionTags = toArray(speciesRecord && speciesRecord.region_tags);
        var visible = farmRaisedFlow
          ? farmSpecies
          : (!farmSpecies && (!harvestState
            || (allowedSpecies.length ? allowedSpecies.indexOf(option.value) >= 0 : (!region || !regionTags.length || regionTags.indexOf(region) >= 0))));
        option.hidden = !visible;
      });

      if (speciesSelect.selectedOptions.length && speciesSelect.selectedOptions[0].hidden) {
        speciesSelect.value = '';
        selectedCuts = [];
        renderSelectedCuts();
      }

      speciesSelect.disabled = !harvestState && !farmRaisedFlow;
      if (speciesHint) {
        if (farmRaisedFlow) {
          speciesHint.textContent = harvestState
            ? 'Farm and ranch species stay available in every state. Use the state field to keep the record tied to the right place.'
            : 'Farm and ranch species stay available everywhere. Add a state when you know where the animal was raised or processed.';
        } else {
          speciesHint.textContent = harvestState
            ? 'Species are filtered to what makes sense for ' + formatStateTitle(harvestState, harvestStateLookup) + '.'
            : 'Choose a harvest state first so Garden & Game can narrow the species list to the right region.';
        }
      }
    }

    function renderSelectedCuts() {
      if (!selectedCutsTarget) return;

      selectedCutsTarget.innerHTML = selectedCuts.map(function (entry, index) {
        return (
          '<div class="platform-cut-entry">' +
            '<div class="platform-cut-entry__top">' +
              '<strong>' + escapeHtml(slugToTitle(entry.cut)) + '</strong>' +
              '<button class="text-link" type="button" data-ftt-remove-cut="' + index + '">Remove</button>' +
            '</div>' +
            '<label class="platform-form__label" for="gg-cut-quantity-' + index + '">Quantity for this cut</label>' +
            '<input id="gg-cut-quantity-' + index + '" class="platform-form__input" type="text" value="' + escapeHtml(entry.quantity || '') + '" placeholder="2 loins, 1 roast, 4 fillets" data-ftt-cut-quantity="' + index + '">' +
          '</div>'
        );
      }).join('');

      if (selectedCutsEmpty) selectedCutsEmpty.hidden = selectedCuts.length > 0;

      Array.prototype.slice.call(selectedCutsTarget.querySelectorAll('[data-ftt-cut-quantity]')).forEach(function (input) {
        input.addEventListener('input', function () {
          var index = parseInt(input.getAttribute('data-ftt-cut-quantity'), 10);
          if (selectedCuts[index]) selectedCuts[index].quantity = input.value || '';
        });
      });

      Array.prototype.slice.call(selectedCutsTarget.querySelectorAll('[data-ftt-remove-cut]')).forEach(function (button) {
        button.addEventListener('click', function () {
          var index = parseInt(button.getAttribute('data-ftt-remove-cut'), 10);
          selectedCuts.splice(index, 1);
          renderSelectedCuts();
          renderCutTiles();
        });
      });
    }

    function renderCutTiles() {
      if (!cutGrid) return;
      var species = speciesSelect ? speciesSelect.value : '';
      if (!species) {
        cutGrid.innerHTML = '';
        if (cutHint) cutHint.textContent = 'Select a species first to load the compatible cuts.';
        return;
      }

      var compatibleCuts = cutData.filter(function (cut) {
        return toArray(cut.species_slugs).indexOf(species) >= 0;
      });

      if (cutHint) {
        cutHint.textContent = compatibleCuts.length
          ? 'Tap each cut you want to log from this harvest. You can add more than one.'
          : 'No compatible cuts were found for this species.';
      }

      cutGrid.innerHTML = compatibleCuts.map(function (cut) {
        var isSelected = selectedCuts.some(function (entry) { return entry.cut === cut.slug; });
        return (
          '<button class="platform-cut-tile' + (isSelected ? ' is-selected' : '') + '" type="button" data-ftt-add-cut="' + escapeHtml(cut.slug) + '">' +
            '<span class="platform-cut-tile__title">' + escapeHtml(cut.title) + '</span>' +
            '<span class="platform-cut-tile__meta">' + (isSelected ? 'Added to this harvest' : 'Add this cut') + '</span>' +
          '</button>'
        );
      }).join('');

      Array.prototype.slice.call(cutGrid.querySelectorAll('[data-ftt-add-cut]')).forEach(function (button) {
        button.addEventListener('click', function () {
          var slug = button.getAttribute('data-ftt-add-cut');
          if (selectedCuts.some(function (entry) { return entry.cut === slug; })) return;
          selectedCuts.push({ cut: slug, quantity: '' });
          renderSelectedCuts();
          renderCutTiles();
        });
      });
    }

    if (speciesSelect) {
      speciesSelect.addEventListener('change', function () {
        selectedCuts = [];
        renderSelectedCuts();
        renderCutTiles();
      });
      renderCutTiles();
    }

    if (harvestStateSelect) {
      harvestStateSelect.addEventListener('change', function () {
        filterSpeciesOptions();
        renderCutTiles();
      });
    }

    if (harvestTypeSelect) {
      harvestTypeSelect.addEventListener('change', function () {
        filterSpeciesOptions();
        renderCutTiles();
      });
    }

    filterSpeciesOptions();
    renderCutTiles();

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      var payload = {
        id: buildClientId('harvest'),
        harvest_type: form.querySelector('[name="harvest_type"]').value || 'hunt',
        species: speciesSelect ? speciesSelect.value : '',
        cuts: selectedCuts.map(function (entry) {
          return { cut: entry.cut, quantity: entry.quantity || '', notes: entry.notes || '' };
        }),
        harvest_state: harvestStateSelect ? harvestStateSelect.value : '',
        date: form.querySelector('[name="harvest_date"]').value || '',
        source: form.querySelector('[name="source"]').value || '',
        location_nickname: form.querySelector('[name="location_nickname"]').value || '',
        quantity_kept: form.querySelector('[name="quantity_kept"]').value || '',
        method_label: form.querySelector('[name="method_label"]').value || '',
        weather_notes: form.querySelector('[name="weather_notes"]').value || '',
        conditions_notes: form.querySelector('[name="conditions_notes"]').value || '',
        companions: form.querySelector('[name="companions"]').value || '',
        processing_notes: form.querySelector('[name="processing_notes"]').value || '',
        notes: form.querySelector('[name="notes"]').value || '',
        journal_title: form.querySelector('[name="journal_title"]').value || '',
        journal_entry: form.querySelector('[name="journal_entry"]').value || '',
        journal_privacy_status: form.querySelector('[name="journal_privacy_status"]').value || 'private',
        summary: ''
      };

      if (!payload.species || !payload.harvest_state || !payload.cuts.length) {
        if (statusTarget) statusTarget.textContent = 'Species, harvest state, and at least one cut are required.';
        return;
      }

      payload.cut = payload.cuts[0].cut;
      payload.quantity = payload.cuts[0].quantity || '';
      payload.summary = slugToTitle(payload.species) + ' | ' + formatStateTitle(payload.harvest_state, harvestStateLookup) + ' | ' + formatCutSummary(payload.cuts);
      saveHarvestLocal(payload);

      if (statusTarget) statusTarget.textContent = 'Saving harvest...';
      var synced = await tryEndpoint(endpoint, payload);
      if (synced && synced.latest_harvest) {
        saveHarvestLocal(synced.latest_harvest);
      }
      if (synced && synced.journal_entry) {
        upsertJournalEntryLocal(synced.journal_entry);
      }
      if (statusTarget) {
        statusTarget.textContent = synced
          ? 'Saved. Taking you to recommendations...'
          : 'Saved on this device. Recommendation flow is still available now.';
      }
      trackEvent('harvest_save', {
        harvestType: payload.harvest_type,
        species: payload.species,
        cutCount: payload.cuts.length,
        harvestState: payload.harvest_state,
        syncStatus: synced ? 'remote' : 'local'
      });

      window.setTimeout(function () {
        window.location.href = getHarvestRecommendationsUrl(0);
      }, 350);
    });
  }

  function syncLinkedHarvestOptions(root, logsOverride) {
    var logs = Array.isArray(logsOverride) ? logsOverride : getHarvestLogs();
    var stateLookup = buildStateLookup(readJsonScript(root, '[data-ftt-states-json]', []));
    Array.prototype.slice.call(root.querySelectorAll('[data-ftt-recipe-linked-harvest], [data-ftt-journal-linked-harvest]')).forEach(function (select) {
      var currentValue = select.value || '';
      select.innerHTML = '<option value="">No linked harvest</option>' + logs.map(function (harvest) {
        var normalized = normalizeHarvest(harvest);
        return '<option value="' + escapeHtml(normalized.id) + '">' + escapeHtml(formatHarvestLabel(normalized, stateLookup) || slugToTitle(normalized.species)) + '</option>';
      }).join('');
      if (currentValue) {
        select.value = currentValue;
      }
    });
  }

  function populateRecipeSpeciesOptions(root) {
    var species = readJsonScript(root, '[data-ftt-species-options-json]', []);
    Array.prototype.slice.call(root.querySelectorAll('[data-ftt-recipe-form]')).forEach(function (form) {
      var typeSelect = form.querySelector('[data-ftt-recipe-species-category]');
      var speciesSelect = form.querySelector('[data-ftt-recipe-species-slug]');
      if (!speciesSelect) return;

      var selectedType = typeSelect ? (typeSelect.value || '') : '';
      var currentValue = speciesSelect.value || '';
      var allowedCategories = getRecipeTypeCategories(selectedType);
      var filteredSpecies = species.filter(function (entry) {
        if (allowedCategories == null) return false;
        if (!allowedCategories.length) return false;
        return allowedCategories.indexOf(entry.category) >= 0;
      });

      speciesSelect.innerHTML = '<option value="">' + getRecipeSpeciesPlaceholder(selectedType) + '</option>' + filteredSpecies.map(function (entry) {
        var label = entry.category ? entry.title + ' | ' + entry.category : entry.title;
        return '<option value="' + escapeHtml(entry.slug) + '">' + escapeHtml(label) + '</option>';
      }).join('');

      speciesSelect.disabled = !selectedType || selectedType === 'garden-based';

      if (currentValue && filteredSpecies.some(function (entry) { return entry.slug === currentValue; })) {
        speciesSelect.value = currentValue;
      } else if (speciesSelect.disabled) {
        speciesSelect.value = '';
      }
    });
  }

  function renderRecipeImagePreview(form, imageUrl) {
    var preview = form.querySelector('[data-ftt-recipe-image-preview]');
    var image = form.querySelector('[data-ftt-recipe-image-preview-img]');
    if (!preview || !image) return;
    if (imageUrl) {
      image.src = imageUrl;
      preview.hidden = false;
    } else {
      image.removeAttribute('src');
      preview.hidden = true;
    }
  }

  async function tryUploadEndpoint(endpoint, formData) {
    if (!endpoint) return false;
    try {
      var response = await fetchWithTimeout(endpoint, {
        method: 'POST',
        credentials: 'include',
        body: formData
      });
      if (!response.ok) return false;
      return await readJsonResponse(response);
    } catch (_error) {
      return false;
    }
  }

  function getRecipeTypeCategories(recipeType) {
    if (!recipeType) return null;
    if (recipeType === 'venison') return ['big-game'];
    if (recipeType === 'beef') return ['beef'];
    if (recipeType === 'pork') return ['pork'];
    if (recipeType === 'chicken') return ['chicken'];
    if (recipeType === 'lamb') return ['lamb'];
    if (recipeType === 'goat') return ['goat'];
    if (recipeType === 'small-game') return ['small-game'];
    if (recipeType === 'duck') return ['waterfowl'];
    if (recipeType === 'fish') return ['freshwater', 'saltwater'];
    if (recipeType === 'upland-bird') return ['upland'];
    if (recipeType === 'garden-based') return [];
    if (recipeType === 'wild-game-garden') return ['big-game', 'small-game', 'upland', 'waterfowl', 'beef', 'pork', 'chicken', 'lamb', 'goat'];
    return [];
  }

  function getRecipeSpeciesPlaceholder(recipeType) {
    if (recipeType === 'garden-based') return 'No species needed for garden-based recipes';
    if (!recipeType) return 'Choose recipe type first';
    return 'Choose species';
  }

  function resetRecipeForm(form) {
    form.reset();
    var idField = form.querySelector('[data-ftt-recipe-id]');
    if (idField) idField.value = '';
    var imageField = form.querySelector('[data-ftt-recipe-image-url]');
    if (imageField) imageField.value = '';
    Array.prototype.slice.call(form.querySelectorAll('input[name="recipe_garden_items[]"]')).forEach(function (input) {
      input.checked = false;
      var tile = input.closest('[data-ftt-recipe-garden-tile]');
      if (tile) tile.classList.remove('is-selected');
    });
    renderRecipeImagePreview(form, '');
  }

  function resetJournalForm(form) {
    form.reset();
    var idField = form.querySelector('[data-ftt-journal-id]');
    if (idField) idField.value = '';
  }

  function resetCookbookForm(form) {
    form.reset();
  }

  function fillRecipeForm(form, recipe) {
    var normalized = normalizeRecipe(recipe);
    if (!normalized) return;
    form.querySelector('[data-ftt-recipe-id]').value = normalized.id || '';
    form.querySelector('[data-ftt-recipe-title]').value = normalized.title || '';
    form.querySelector('[data-ftt-recipe-linked-harvest]').value = normalized.linked_harvest_log_id || '';
    form.querySelector('[data-ftt-recipe-short-description]').value = normalized.short_description || '';
    form.querySelector('[data-ftt-recipe-species-category]').value = normalized.species_category || '';
    populateRecipeSpeciesOptions(form.closest('[data-ftt-root]'));
    form.querySelector('[data-ftt-recipe-species-slug]').value = normalized.species_slug || '';
    form.querySelector('[data-ftt-recipe-prep-time]').value = normalized.prep_time_minutes || '';
    form.querySelector('[data-ftt-recipe-cook-time]').value = normalized.cook_time_minutes || '';
    form.querySelector('[data-ftt-recipe-servings]').value = normalized.servings || '';
    form.querySelector('[data-ftt-recipe-season]').value = normalized.season || '';
    form.querySelector('[data-ftt-recipe-difficulty]').value = normalized.difficulty || '';
    form.querySelector('[data-ftt-recipe-privacy]').value = normalized.privacy_status || 'private';
    form.querySelector('[data-ftt-recipe-image-url]').value = normalized.image_url || '';
    var fileInput = form.querySelector('[data-ftt-recipe-image-file]');
    if (fileInput) fileInput.value = '';
    renderRecipeImagePreview(form, normalized.image_url || '');
    form.querySelector('[data-ftt-recipe-ingredients]').value = normalized.ingredients || '';
    form.querySelector('[data-ftt-recipe-instructions]').value = normalized.instructions || '';
    form.querySelector('[data-ftt-recipe-story]').value = normalized.story || '';
    Array.prototype.slice.call(form.querySelectorAll('input[name="recipe_garden_items[]"]')).forEach(function (input) {
      var checked = normalized.garden_item_slugs.indexOf(input.value) >= 0;
      input.checked = checked;
      var tile = input.closest('[data-ftt-recipe-garden-tile]');
      if (tile) tile.classList.toggle('is-selected', checked);
    });
  }

  function fillJournalForm(form, entry) {
    var normalized = normalizeJournalEntry(entry);
    if (!normalized) return;
    form.querySelector('[data-ftt-journal-id]').value = normalized.id || '';
    form.querySelector('[data-ftt-journal-title]').value = normalized.title || '';
    form.querySelector('[data-ftt-journal-date]').value = normalized.entry_date || '';
    form.querySelector('[data-ftt-journal-linked-harvest]').value = normalized.linked_harvest_log_id || '';
    form.querySelector('[data-ftt-journal-privacy]').value = normalized.privacy_status || 'private';
    form.querySelector('[data-ftt-journal-body]').value = normalized.body || '';
  }

  function renderProfileRecipes(root, recipesOverride) {
    var target = root.querySelector('[data-ftt-profile-recipes]');
    if (!target) return;

    var recipes = Array.isArray(recipesOverride) ? recipesOverride : getSavedRecipes();
    target.innerHTML = recipes.length ? recipes.map(function (recipe) {
      var normalized = normalizeRecipe(recipe);
      var visibility = normalized.privacy_status === 'share_with_garden_and_game' ? 'Submitted for Garden & Game review' : 'Private';
      return (
        '<article class="platform-mini-entry">' +
          '<strong>' + escapeHtml(normalized.title || 'Untitled recipe') + '</strong>' +
          (normalized.short_description ? '<span>' + escapeHtml(normalized.short_description) + '</span>' : '') +
          '<span>' + escapeHtml(visibility) + '</span>' +
          '<span><button class="text-link" type="button" data-ftt-edit-recipe="' + escapeHtml(normalized.id) + '">Edit recipe</button></span>' +
        '</article>'
      );
    }).join('') : '<p class="platform-empty-copy">No personal recipes saved yet. Add one below and decide whether it stays private or is submitted for Garden &amp; Game review.</p>';
  }

  function renderProfileJournalEntries(root, entriesOverride) {
    var target = root.querySelector('[data-ftt-profile-journals]');
    if (!target) return;

    var entries = Array.isArray(entriesOverride) ? entriesOverride : getJournalEntries();
    target.innerHTML = entries.length ? entries.map(function (entry) {
      var normalized = normalizeJournalEntry(entry);
      return (
        '<article class="platform-mini-entry">' +
          '<strong>' + escapeHtml(normalized.title || 'Untitled field note') + '</strong>' +
          (normalized.entry_date ? '<span>' + escapeHtml(normalized.entry_date) + '</span>' : '') +
          (normalized.body ? '<span>' + escapeHtml(normalized.body.slice(0, 180) + (normalized.body.length > 180 ? '...' : '')) + '</span>' : '') +
          '<span><button class="text-link" type="button" data-ftt-edit-journal="' + escapeHtml(normalized.id) + '">Edit field notes</button></span>' +
        '</article>'
      );
    }).join('') : '<p class="platform-empty-copy">No field notes saved yet. Harvest journals and standalone notes will both collect here.</p>';
  }

  function renderProfileCookbookProjects(root, projectsOverride) {
    var target = root.querySelector('[data-ftt-profile-cookbooks]');
    if (!target) return;

    var projects = Array.isArray(projectsOverride) ? projectsOverride : getCookbookProjects();
    target.innerHTML = projects.length ? projects.map(function (project) {
      var normalized = normalizeCookbookProject(project);
      var counts = normalized.source_counts || {};
      return (
        '<article class="platform-mini-entry">' +
          '<strong>' + escapeHtml(normalized.title || 'Untitled cookbook') + '</strong>' +
          '<span>' + escapeHtml(slugToTitle((normalized.book_type || '').replace(/_/g, '-'))) + '</span>' +
          (normalized.subtitle ? '<span>' + escapeHtml(normalized.subtitle) + '</span>' : '') +
          '<span>Sources: ' + escapeHtml(String(counts.recipes || 0)) + ' recipes | ' + escapeHtml(String(counts.harvests || 0)) + ' harvests | ' + escapeHtml(String(counts.journal_entries || 0)) + ' field notes</span>' +
        '</article>'
      );
    }).join('') : '<p class="platform-empty-copy">No cookbook drafts started yet. Start one below and Garden &amp; Game will begin assembling the pieces already in your account.</p>';
  }

  function openProfileModal(root, modalName) {
    var modal = root.querySelector('[data-ftt-modal="' + modalName + '"]');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    modal.hidden = false;
    document.documentElement.classList.add('gg-modal-open');
    document.body.classList.add('gg-modal-open');
    window.setTimeout(function () {
      var focusTarget = modal.querySelector('.platform-modal__dialog input, .platform-modal__dialog select, .platform-modal__dialog textarea, .platform-modal__dialog button');
      if (focusTarget) focusTarget.focus();
    }, 0);
  }

  function closeProfileModal(root, modalName) {
    var modal = root.querySelector('[data-ftt-modal="' + modalName + '"]');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    if (!root.querySelector('[data-ftt-modal]:not([hidden])')) {
      document.documentElement.classList.remove('gg-modal-open');
      document.body.classList.remove('gg-modal-open');
      if (root.__ggLastModalTrigger && typeof root.__ggLastModalTrigger.focus === 'function') {
        root.__ggLastModalTrigger.focus();
      }
      root.__ggLastModalTrigger = null;
    }
  }

  function closeAllProfileModals(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-ftt-modal]')).forEach(function (modal) {
      modal.setAttribute('aria-hidden', 'true');
      modal.hidden = true;
    });
    document.documentElement.classList.remove('gg-modal-open');
    document.body.classList.remove('gg-modal-open');
    if (root.__ggLastModalTrigger && typeof root.__ggLastModalTrigger.focus === 'function') {
      root.__ggLastModalTrigger.focus();
    }
    root.__ggLastModalTrigger = null;
  }

  function trapModalFocus(root, event) {
    if (event.key !== 'Tab') return;
    var openModal = root.querySelector('[data-ftt-modal]:not([hidden]) .platform-modal__dialog');
    if (!openModal) return;

    var focusable = Array.prototype.slice.call(openModal.querySelectorAll('a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (node) {
        return !!(node.offsetWidth || node.offsetHeight || node.getClientRects().length);
      });

    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;

    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function bindProfileModalButtons(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-ftt-open-modal]')).forEach(function (button) {
      if (button.getAttribute('data-ftt-bound') === 'true') return;
      button.setAttribute('data-ftt-bound', 'true');
      button.addEventListener('click', function () {
        root.__ggLastModalTrigger = button;
        var modalName = button.getAttribute('data-ftt-open-modal');
        if (modalName === 'recipe') {
          var recipeForm = root.querySelector('[data-ftt-recipe-form]');
          if (recipeForm) resetRecipeForm(recipeForm);
        }
        if (modalName === 'journal') {
          var journalForm = root.querySelector('[data-ftt-journal-form]');
          if (journalForm) resetJournalForm(journalForm);
        }
        if (modalName === 'cookbook') {
          var cookbookForm = root.querySelector('[data-ftt-cookbook-form]');
          if (cookbookForm) resetCookbookForm(cookbookForm);
        }
        openProfileModal(root, modalName);
      });
    });

    Array.prototype.slice.call(root.querySelectorAll('[data-ftt-close-modal]')).forEach(function (button) {
      if (button.getAttribute('data-ftt-bound') === 'true') return;
      button.setAttribute('data-ftt-bound', 'true');
      button.addEventListener('click', function () {
        closeAllProfileModals(root);
      });
    });

    if (!root.__ggModalKeydownBound) {
      root.__ggModalKeydownBound = true;
      root.addEventListener('keydown', function (event) {
        trapModalFocus(root, event);
      });
    }
  }

  function bindProfileEditorButtons(root) {
    var accountState = ensureRootAccountState(root);
    var recipeForm = root.querySelector('[data-ftt-recipe-form]');
    var journalForm = root.querySelector('[data-ftt-journal-form]');

    Array.prototype.slice.call(root.querySelectorAll('[data-ftt-edit-recipe]')).forEach(function (button) {
      if (button.getAttribute('data-ftt-bound') === 'true') return;
      button.setAttribute('data-ftt-bound', 'true');
        button.addEventListener('click', function () {
          var recipeId = button.getAttribute('data-ftt-edit-recipe');
          var recipe = (accountState.recipes || []).find(function (entry) {
            return entry.id === recipeId;
          });
          if (!recipeForm || !recipe) return;
          root.__ggLastModalTrigger = button;
          fillRecipeForm(recipeForm, recipe);
          openProfileModal(root, 'recipe');
        });
      });

      Array.prototype.slice.call(root.querySelectorAll('[data-ftt-edit-journal]')).forEach(function (button) {
        if (button.getAttribute('data-ftt-bound') === 'true') return;
      button.setAttribute('data-ftt-bound', 'true');
        button.addEventListener('click', function () {
          var journalId = button.getAttribute('data-ftt-edit-journal');
          var entry = (accountState.journalEntries || []).find(function (item) {
            return item.id === journalId;
          });
          if (!journalForm || !entry) return;
          root.__ggLastModalTrigger = button;
          fillJournalForm(journalForm, entry);
          openProfileModal(root, 'journal');
        });
      });
  }

  function initRecipeForm(form, root) {
    var endpoint = form.getAttribute('data-endpoint') || root.getAttribute('data-ftt-recipes-endpoint');
    var uploadEndpoint = root.getAttribute('data-ftt-uploads-endpoint') || '';
    var statusTarget = form.querySelector('[data-ftt-recipe-status]');
    var typeSelect = form.querySelector('[data-ftt-recipe-species-category]');
    var imageFileInput = form.querySelector('[data-ftt-recipe-image-file]');
    var imageUrlField = form.querySelector('[data-ftt-recipe-image-url]');

    Array.prototype.slice.call(form.querySelectorAll('input[name="recipe_garden_items[]"]')).forEach(function (input) {
      input.addEventListener('change', function () {
        var tile = input.closest('[data-ftt-recipe-garden-tile]');
        if (tile) tile.classList.toggle('is-selected', input.checked);
      });
    });

    if (typeSelect) {
      typeSelect.addEventListener('change', function () {
        populateRecipeSpeciesOptions(root);
      });
    }

    if (imageFileInput) {
      imageFileInput.addEventListener('change', function () {
        var file = imageFileInput.files && imageFileInput.files[0];
        if (!file) {
          renderRecipeImagePreview(form, imageUrlField ? imageUrlField.value : '');
          return;
        }
        var objectUrl = URL.createObjectURL(file);
        renderRecipeImagePreview(form, objectUrl);
      });
    }

    populateRecipeSpeciesOptions(root);

    var resetButton = form.querySelector('[data-ftt-recipe-reset]');
    if (resetButton) {
      resetButton.addEventListener('click', function () {
        resetRecipeForm(form);
        populateRecipeSpeciesOptions(root);
        if (statusTarget) statusTarget.textContent = '';
      });
    }

      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        var activeImageUrl = imageUrlField ? (imageUrlField.value || '') : '';
        var imageFile = imageFileInput && imageFileInput.files ? imageFileInput.files[0] : null;

        if (imageFile) {
          if (statusTarget) statusTarget.textContent = 'Uploading image...';
          var uploadData = new FormData();
          uploadData.append('file', imageFile);
          uploadData.append('kind', 'recipe-image');
          var uploadResult = await tryUploadEndpoint(uploadEndpoint, uploadData);
          if (!uploadResult || !uploadResult.image_url) {
            if (statusTarget) statusTarget.textContent = 'Image upload failed. Try again before saving the recipe.';
            return;
          }
          activeImageUrl = uploadResult.image_url;
          if (imageUrlField) imageUrlField.value = activeImageUrl;
          renderRecipeImagePreview(form, activeImageUrl);
        }

        var payload = {
          id: form.querySelector('[data-ftt-recipe-id]').value || buildClientId('recipe'),
          title: form.querySelector('[data-ftt-recipe-title]').value || '',
          linked_harvest_log_id: form.querySelector('[data-ftt-recipe-linked-harvest]').value || '',
          short_description: form.querySelector('[data-ftt-recipe-short-description]').value || '',
        species_category: form.querySelector('[data-ftt-recipe-species-category]').value || '',
        species_slug: form.querySelector('[data-ftt-recipe-species-slug]').value || '',
        prep_time_minutes: form.querySelector('[data-ftt-recipe-prep-time]').value || '',
        cook_time_minutes: form.querySelector('[data-ftt-recipe-cook-time]').value || '',
          servings: form.querySelector('[data-ftt-recipe-servings]').value || '',
          season: form.querySelector('[data-ftt-recipe-season]').value || '',
          difficulty: form.querySelector('[data-ftt-recipe-difficulty]').value || '',
          privacy_status: form.querySelector('[data-ftt-recipe-privacy]').value || 'private',
          image_url: activeImageUrl,
          garden_item_slugs: Array.prototype.slice.call(form.querySelectorAll('input[name="recipe_garden_items[]"]:checked')).map(function (input) {
            return input.value;
          }),
          ingredients: form.querySelector('[data-ftt-recipe-ingredients]').value || '',
        instructions: form.querySelector('[data-ftt-recipe-instructions]').value || '',
        story: form.querySelector('[data-ftt-recipe-story]').value || ''
      };

      var normalized = normalizeRecipe(payload);
      upsertRecipeLocal(normalized);
      var accountState = ensureRootAccountState(root);
      accountState.recipes = getSavedRecipes();
      renderProfileRecipes(root, accountState.recipes);
      bindProfileEditorButtons(root);

      if (statusTarget) statusTarget.textContent = 'Saving recipe...';
      var synced = await tryEndpoint(endpoint, payload);
      if (synced && Array.isArray(synced.recipes)) {
        saveRecipesLocal(synced.recipes);
        accountState.recipes = getSavedRecipes();
        renderProfileRecipes(root, accountState.recipes);
        bindProfileEditorButtons(root);
      }
      if (statusTarget) {
        statusTarget.textContent = synced
          ? 'Recipe saved to your account.'
          : 'Recipe saved on this device. Account sync will catch up if the endpoint is unavailable.';
      }
      trackEvent('recipe_submit', {
        recipeId: payload.id,
        speciesCategory: payload.species_category,
        speciesSlug: payload.species_slug,
        privacyStatus: payload.privacy_status,
        syncStatus: synced ? 'remote' : 'local'
      });
      window.setTimeout(function () {
        closeProfileModal(root, 'recipe');
        resetRecipeForm(form);
      }, 450);
    });
  }

  function initJournalForm(form, root) {
    var endpoint = form.getAttribute('data-endpoint') || root.getAttribute('data-ftt-journal-endpoint');
    var statusTarget = form.querySelector('[data-ftt-journal-status]');
    var resetButton = form.querySelector('[data-ftt-journal-reset]');

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        resetJournalForm(form);
        if (statusTarget) statusTarget.textContent = '';
      });
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var payload = {
        id: form.querySelector('[data-ftt-journal-id]').value || buildClientId('journal'),
        title: form.querySelector('[data-ftt-journal-title]').value || '',
        entry_date: form.querySelector('[data-ftt-journal-date]').value || '',
        linked_harvest_log_id: form.querySelector('[data-ftt-journal-linked-harvest]').value || '',
        privacy_status: form.querySelector('[data-ftt-journal-privacy]').value || 'private',
        body: form.querySelector('[data-ftt-journal-body]').value || '',
        entry_type: 'journal'
      };

      var normalized = normalizeJournalEntry(payload);
      upsertJournalEntryLocal(normalized);
      var accountState = ensureRootAccountState(root);
      accountState.journalEntries = getJournalEntries();
      renderProfileJournalEntries(root, accountState.journalEntries);
      bindProfileEditorButtons(root);

      if (statusTarget) statusTarget.textContent = 'Saving field notes...';
      var synced = await tryEndpoint(endpoint, payload);
      if (synced && Array.isArray(synced.journal_entries)) {
        saveJournalEntriesLocal(synced.journal_entries);
        accountState.journalEntries = getJournalEntries();
        renderProfileJournalEntries(root, accountState.journalEntries);
        bindProfileEditorButtons(root);
      }
      if (statusTarget) {
        statusTarget.textContent = synced
          ? 'Field notes saved to your account.'
          : 'Field notes saved on this device. Account sync will catch up if the endpoint is unavailable.';
      }
      trackEvent('journal_submit', {
        journalId: payload.id,
        linkedHarvestId: payload.linked_harvest_log_id,
        privacyStatus: payload.privacy_status,
        syncStatus: synced ? 'remote' : 'local'
      });
      window.setTimeout(function () {
        closeProfileModal(root, 'journal');
        resetJournalForm(form);
      }, 450);
    });
  }

  function initCookbookForm(form, root) {
    var endpoint = form.getAttribute('data-endpoint') || root.getAttribute('data-ftt-cookbook-endpoint');
    var statusTarget = form.querySelector('[data-ftt-cookbook-status]');

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var accountState = ensureRootAccountState(root);
      var payload = {
        id: buildClientId('cookbook'),
        title: form.querySelector('[data-ftt-cookbook-title]').value || '',
        book_type: form.querySelector('[data-ftt-cookbook-type]').value || 'family_field_to_table',
        subtitle: form.querySelector('[data-ftt-cookbook-subtitle]').value || '',
        dedication: form.querySelector('[data-ftt-cookbook-dedication]').value || '',
        include_recipe_ids: (accountState.recipes || []).map(function (recipe) { return recipe.id; }),
        include_harvest_ids: (accountState.harvestLogs || []).map(function (harvest) { return harvest.id; }),
        include_journal_entry_ids: (accountState.journalEntries || []).map(function (entry) { return entry.id; })
      };

      var normalized = normalizeCookbookProject({
        id: payload.id,
        title: payload.title,
        subtitle: payload.subtitle,
        dedication: payload.dedication,
        book_type: payload.book_type,
        status: 'draft',
        source_counts: {
          recipes: (accountState.recipes || []).length,
          harvests: (accountState.harvestLogs || []).length,
          journal_entries: (accountState.journalEntries || []).length
        }
      });

      upsertCookbookProjectLocal(normalized);
      accountState.cookbookProjects = getCookbookProjects();
      renderProfileCookbookProjects(root, accountState.cookbookProjects);

      if (statusTarget) statusTarget.textContent = 'Starting cookbook draft...';
      var synced = await tryEndpoint(endpoint, payload);
      if (synced && Array.isArray(synced.cookbook_projects)) {
        saveCookbookProjectsLocal(synced.cookbook_projects);
        accountState.cookbookProjects = getCookbookProjects();
        renderProfileCookbookProjects(root, accountState.cookbookProjects);
      }
      if (statusTarget) {
        statusTarget.textContent = synced
          ? 'Cookbook draft saved. Next we can turn this into a fuller builder and print flow.'
          : 'Cookbook draft saved on this device. Account sync will catch up if the endpoint is unavailable.';
      }
      trackEvent('cookbook_draft_create', {
        cookbookId: payload.id,
        bookType: payload.book_type,
        recipeCount: payload.include_recipe_ids.length,
        harvestCount: payload.include_harvest_ids.length,
        journalCount: payload.include_journal_entry_ids.length,
        syncStatus: synced ? 'remote' : 'local'
      });
      window.setTimeout(function () {
        closeProfileModal(root, 'cookbook');
        resetCookbookForm(form);
      }, 450);
    });
  }

  function buildRecipeMatchCard(match, gardenLookup, stateLookup) {
    var displayTitle = getRecipeDisplayTitle(match.recipe, stateLookup);
    return (
      '<article class="platform-result-card">' +
        '<span class="match-pill match-pill--default">' + escapeHtml(tierLabel(match.tier)) + '</span>' +
        (match.matchedCut ? '<p class="content-card__date">Built for ' + escapeHtml(slugToTitle(match.matchedCut)) + '</p>' : '') +
        '<h4>' + escapeHtml(displayTitle) + '</h4>' +
        '<p>' + escapeHtml(match.recipe.short_description || 'A useful fit for what you have on hand right now.') + '</p>' +
        (match.gardenMatches.length ? '<p class="content-card__date">Uses from your garden: ' + escapeHtml(formatGardenItems(match.gardenMatches, gardenLookup).join(', ')) + '</p>' : '') +
        (formatTime(match.recipe) ? '<p class="content-card__date">' + escapeHtml(formatTime(match.recipe)) + '</p>' : '') +
        '<div class="platform-result-card__actions">' +
          renderOpenLink(match.recipe.url, 'Open recipe') +
          renderFavoriteButton(match.recipe, displayTitle) +
        '</div>' +
      '</article>'
    );
  }

  async function renderDashboard(root) {
    var initialProfile = readJsonScript(root, '[data-ftt-dashboard-profile]', { state: '', garden_items: [], latest_harvest: null });
    var states = readJsonScript(root, '[data-ftt-states-json]', []);
    var gardenItems = readJsonScript(root, '[data-ftt-garden-items-json]', []);
    var stateLookup = buildStateLookup(states);
    var gardenLookup = buildGardenLookup(gardenItems);

    var titleTarget = root.querySelector('[data-ftt-dashboard-title]');
    var subtitleTarget = root.querySelector('[data-ftt-dashboard-subtitle]');
    var gardenTarget = root.querySelector('[data-ftt-dashboard-garden]');
    var gardenEmpty = root.querySelector('[data-ftt-dashboard-garden-empty]');
    var harvestTarget = root.querySelector('[data-ftt-dashboard-harvest]');
    var harvestEmpty = root.querySelector('[data-ftt-dashboard-harvest-empty]');
    var wildlifeTarget = root.querySelector('[data-ftt-dashboard-wildlife]');
    var wildlifeEmpty = root.querySelector('[data-ftt-dashboard-wildlife-empty]');
    var actionsTarget = root.querySelector('[data-ftt-dashboard-actions]');
    var recipesTarget = root.querySelector('[data-ftt-dashboard-recipes]');
    var recipesEmpty = root.querySelector('[data-ftt-dashboard-recipes-empty]');

    if (subtitleTarget) subtitleTarget.textContent = 'Loading your saved season...';
    renderMessage(gardenTarget, 'Loading saved ingredients...');
    renderMessage(harvestTarget, 'Loading latest harvest...');
    renderMessage(wildlifeTarget, 'Loading state resources...');
    renderMessage(actionsTarget, 'Loading next steps...');
    renderMessage(recipesTarget, 'Loading recommendations...');
    setHidden(gardenEmpty, true);
    setHidden(harvestEmpty, true);
    setHidden(wildlifeEmpty, true);
    setHidden(recipesEmpty, true);

    var accountState = await loadAccountState(initialProfile);
    var profile = accountState.profile;
    var harvest = accountState.latestHarvest;
    var recipes = await loadRecipesForSpecies(root, harvest && harvest.species);
    var recipeMatches = computeRecipeMatches(profile, harvest, recipes).slice(0, 3);

    var stateRecord = stateLookup[profile.state];
    if (titleTarget) titleTarget.textContent = stateRecord ? stateRecord.title : 'Your Season';
    if (subtitleTarget) {
      var baseSubtitle = stateRecord && stateRecord.seasonal_copy
        ? stateRecord.seasonal_copy
        : 'Build your state, garden, and harvest profile so the platform can give you something useful back.';
      subtitleTarget.textContent = accountState.syncStatus === 'remote'
        ? baseSubtitle
        : baseSubtitle + ' You are viewing the saved-on-this-device version while account sync is unavailable.';
    }

    var gardenLabels = formatGardenItems(profile.garden_items, gardenLookup);
    if (gardenTarget) {
      gardenTarget.innerHTML = gardenLabels.map(function (label) {
        return '<span class="chip">' + escapeHtml(label) + '</span>';
      }).join('');
    }
    setHidden(gardenEmpty, gardenLabels.length > 0);

    if (wildlifeTarget) {
      var wildlifeUrl = getWildlifeAgencyUrl(profile.state);
      wildlifeTarget.innerHTML = wildlifeUrl && stateRecord ? (
        '<div class="platform-resource-card">' +
          '<strong>Official ' + escapeHtml(stateRecord.title) + ' seasons, regulations &amp; licensing</strong>' +
          '<p>Keep bag limits, season dates, and public land guidance one click away from your dashboard.</p>' +
          '<span><a class="text-link" href="' + escapeHtml(wildlifeUrl) + '" target="_blank" rel="noopener noreferrer">Open ' + escapeHtml(stateRecord.title) + ' Parks &amp; Wildlife &rarr;</a></span>' +
        '</div>'
      ) : '';
    }
    setHidden(wildlifeEmpty, !!(stateRecord && getWildlifeAgencyUrl(profile.state)));

    if (harvestTarget) {
      harvestTarget.innerHTML = harvest ? (
        '<div class="platform-mini-summary">' +
          '<strong>' + escapeHtml(slugToTitle(harvest.species)) + '</strong>' +
          (harvest.harvest_state ? '<span>Harvested in ' + escapeHtml(formatStateTitle(harvest.harvest_state, stateLookup)) + '</span>' : '') +
          (getSelectedCuts(harvest).length ? '<span>' + escapeHtml(formatCutSummary(getSelectedCuts(harvest))) + '</span>' : '') +
          (harvest.date ? '<span>' + escapeHtml(harvest.date) + '</span>' : '') +
          '<span><a class="text-link" href="/pages/platform-profile">View all harvests &rarr;</a></span>' +
          '</div>'
      ) : '';
    }
    setHidden(harvestEmpty, !!harvest);

    if (actionsTarget) {
      var actions = [];
      if (!profile.state) actions.push('Choose your state so recommendations can start with the place you actually live.');
      if (!gardenLabels.length) actions.push('Select what is growing now so recipes can use ingredients you already have.');
      if (!harvest) actions.push('Log a harvest to move from profile setup into recipe and technique recommendations.');
      if (profile.state && gardenLabels.length && harvest) actions.push('Open recommendations to see the strongest uses for what is on hand right now.');
      actionsTarget.innerHTML = actions.map(function (item) {
        return '<li>' + escapeHtml(item) + '</li>';
      }).join('');
    }

    if (recipesTarget) {
      recipesTarget.innerHTML = recipeMatches.map(function (match) {
        return buildRecipeMatchCard(match, gardenLookup, stateLookup);
      }).join('');
      bindFavoriteButtons(recipesTarget);
    }
    setHidden(recipesEmpty, recipeMatches.length > 0);
  }

  async function renderRecommendations(root) {
    var initialProfile = readJsonScript(root, '[data-ftt-recommendations-profile]', { state: '', garden_items: [], latest_harvest: null });
    var states = readJsonScript(root, '[data-ftt-states-json]', []);
    var gardenItems = readJsonScript(root, '[data-ftt-garden-items-json]', []);
    var techniques = readJsonScript(root, '[data-ftt-techniques-json]', []);
    var stateLookup = buildStateLookup(states);
    var gardenLookup = buildGardenLookup(gardenItems);

    var contextTarget = root.querySelector('[data-ftt-recommendations-context]');
    var gardenTarget = root.querySelector('[data-ftt-recommendations-garden]');
    var recipeTarget = root.querySelector('[data-ftt-recipe-results]');
    var recipeEmpty = root.querySelector('[data-ftt-recipe-results-empty]');
    var techniqueTarget = root.querySelector('[data-ftt-technique-results]');
    var techniqueEmpty = root.querySelector('[data-ftt-technique-results-empty]');
    var introTarget = root.querySelector('[data-ftt-recommendations-intro]');

    if (introTarget) introTarget.textContent = 'Loading recommendation context...';
    renderMessage(contextTarget, 'Loading saved state and harvest context...');
    renderMessage(gardenTarget, 'Loading garden overlap...');
    renderMessage(recipeTarget, 'Loading recipe matches...');
    renderMessage(techniqueTarget, 'Loading preparation guidance...');
    setHidden(recipeEmpty, true);
    setHidden(techniqueEmpty, true);

    var accountState = await loadAccountState(initialProfile);
    var profile = accountState.profile;
    var harvest = getActiveHarvest(accountState.latestHarvest);
    var recipes = await loadRecipesForSpecies(root, harvest && harvest.species);
    var recipeMatches = computeRecipeMatches(profile, harvest, recipes).slice(0, 8);
    var techniqueMatches = computeTechniqueMatches(harvest, techniques).slice(0, 6);

    if (introTarget) {
      var intro = hasRequestedHarvestOverride()
        ? 'These suggestions are tied to the harvest you selected from your history, using the state you live in and the ingredients already in your garden profile.'
        : 'These suggestions are shaped by the state you selected, what you said is growing, and the harvest you most recently logged.';
      introTarget.textContent = accountState.syncStatus === 'remote'
        ? intro
        : intro + ' You are viewing the saved-on-this-device version while account sync is unavailable.';
    }

    if (contextTarget) {
      var contextBits = [];
      var stateRecord = stateLookup[profile.state];
      if (stateRecord) contextBits.push('<span class="chip">Lives in ' + escapeHtml(stateRecord.title) + '</span>');
      if (harvest && harvest.harvest_state) contextBits.push('<span class="chip">Harvested in ' + escapeHtml(formatStateTitle(harvest.harvest_state, stateLookup)) + '</span>');
      if (harvest && harvest.species) contextBits.push('<span class="chip">' + escapeHtml(slugToTitle(harvest.species)) + '</span>');
      getSelectedCuts(harvest).forEach(function (entry) {
        contextBits.push('<span class="chip">' + escapeHtml(slugToTitle(entry.cut)) + '</span>');
      });
      contextTarget.innerHTML = contextBits.length ? contextBits.join('') : '<p class="platform-empty-copy">No state or harvest context is saved yet.</p>';
    }

    if (gardenTarget) {
      gardenTarget.innerHTML = formatGardenItems(profile.garden_items, gardenLookup).map(function (label) {
        return '<span class="chip">' + escapeHtml(label) + '</span>';
      }).join('');
    }

    if (recipeTarget) {
      var recipeGroups = groupMatchesByCut(recipeMatches);
      recipeTarget.innerHTML = Object.keys(recipeGroups).map(function (cutKey) {
        return (
          '<section class="platform-result-group">' +
            '<h3 class="platform-result-group__title">' + escapeHtml(cutKey === 'general' ? 'General matches' : slugToTitle(cutKey)) + '</h3>' +
            recipeGroups[cutKey].map(function (match) {
              return buildRecipeMatchCard(match, gardenLookup, stateLookup);
            }).join('') +
          '</section>'
        );
      }).join('');
      bindFavoriteButtons(recipeTarget);
    }
    setHidden(recipeEmpty, recipeMatches.length > 0);

    if (techniqueTarget) {
      var techniqueGroups = groupMatchesByCut(techniqueMatches);
      techniqueTarget.innerHTML = Object.keys(techniqueGroups).map(function (cutKey) {
        return (
          '<section class="platform-result-group">' +
            '<h3 class="platform-result-group__title">' + escapeHtml(cutKey === 'general' ? 'General technique' : slugToTitle(cutKey)) + '</h3>' +
            techniqueGroups[cutKey].map(function (match) {
              return (
                '<article class="platform-result-card">' +
                  '<span class="match-pill match-pill--default">Technique</span>' +
                  '<h4>' + escapeHtml(match.technique.title) + '</h4>' +
                  '<p>' + escapeHtml(match.technique.short_description || match.technique.why_it_matters || '') + '</p>' +
                  (match.technique.why_it_matters ? '<p class="content-card__date">' + escapeHtml(match.technique.why_it_matters) + '</p>' : '') +
                  renderOpenLink(match.technique.url, 'Open technique') +
                '</article>'
              );
            }).join('') +
          '</section>'
        );
      }).join('');
    }
    setHidden(techniqueEmpty, techniqueMatches.length > 0);
  }

  function renderProfileHarvests(root, logsOverride) {
    var target = root.querySelector('[data-ftt-profile-harvests]');
    if (!target) return;

    var logs = Array.isArray(logsOverride) ? logsOverride : getHarvestLogs();
    var stateLookup = buildStateLookup(readJsonScript(root, '[data-ftt-states-json]', []));
    target.innerHTML = logs.length ? logs.map(function (normalized, index) {
      return (
        '<article class="platform-mini-entry">' +
          '<strong>' + escapeHtml(slugToTitle(normalized.species)) + '</strong>' +
          (normalized.harvest_state ? '<span>Harvested in ' + escapeHtml(formatStateTitle(normalized.harvest_state, stateLookup)) + '</span>' : '') +
          (getSelectedCuts(normalized).length ? '<span>' + escapeHtml(formatCutSummary(getSelectedCuts(normalized))) + '</span>' : '') +
          (normalized.date ? '<span>' + escapeHtml(normalized.date) + '</span>' : '') +
          '<span><a class="text-link" href="' + escapeHtml(getHarvestRecommendationsUrl(index)) + '">View recipes &amp; techniques &rarr;</a></span>' +
        '</article>'
      );
    }).join('') : '<p class="platform-empty-copy">No harvest logs saved yet.</p>';
  }

  function renderProfileFavorites(root, favoritesOverride) {
    var target = root.querySelector('[data-ftt-profile-favorites]');
    if (!target) return;

    var favorites = Array.isArray(favoritesOverride) ? favoritesOverride : getFavoriteRecipes();
    target.innerHTML = favorites.length ? favorites.map(function (recipe) {
      return (
        '<article class="platform-mini-entry">' +
          '<strong>' + escapeHtml(recipe.title || slugToTitle(recipe.slug)) + '</strong>' +
          (recipe.url ? '<span><a class="text-link" href="' + escapeHtml(recipe.url) + '">Open recipe &rarr;</a></span>' : '') +
        '</article>'
      );
    }).join('') : '<p class="platform-empty-copy">No favorite recipes saved yet. Open any harvest to see tailored recipes and save the ones worth keeping.</p>';
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ftt-root]').forEach(function (root) {
      var endpoint = root.getAttribute('data-endpoint');
      if (!endpoint) return;
      root.dispatchEvent(new CustomEvent('gg:section-mounted', {
        bubbles: true,
        detail: { endpoint: endpoint, section: root.getAttribute('data-ftt-root') }
      }));
    });

    document.querySelectorAll('[data-ftt-onboarding-form]').forEach(function (form) {
      initProfileForm(form, '/pages/platform-dashboard');
    });

    document.querySelectorAll('[data-ftt-profile-form]').forEach(async function (form) {
      initProfileForm(form, '');
      var root = form.closest('[data-ftt-root]');
      var profileStatusTarget = form.querySelector('[data-ftt-onboarding-status]');
      renderProfileLoadingState(root);
      var initialProfile = {
        state: form.getAttribute('data-initial-state') || '',
        garden_items: safeParse(form.getAttribute('data-initial-garden'), []),
        latest_harvest: null
      };
      var accountState = await loadAccountState(initialProfile);
      setRootAccountState(root, accountState);
      if (profileStatusTarget && accountState.syncStatus !== 'remote') {
        profileStatusTarget.textContent = 'Account sync is temporarily unavailable. You can still work from the saved-on-this-device version.';
      }
      syncLinkedHarvestOptions(root, accountState.harvestLogs);
      populateRecipeSpeciesOptions(root);
      bindProfileModalButtons(root);
      renderProfileHarvests(root, accountState.harvestLogs);
      renderProfileFavorites(root, accountState.favoriteRecipes);
      renderProfileRecipes(root, accountState.recipes);
      renderProfileJournalEntries(root, accountState.journalEntries);
      renderProfileCookbookProjects(root, accountState.cookbookProjects);
      bindProfileEditorButtons(root);

      var recipeForm = root.querySelector('[data-ftt-recipe-form]');
      if (recipeForm) initRecipeForm(recipeForm, root);

      var journalForm = root.querySelector('[data-ftt-journal-form]');
      if (journalForm) initJournalForm(journalForm, root);

      var cookbookForm = root.querySelector('[data-ftt-cookbook-form]');
      if (cookbookForm) initCookbookForm(cookbookForm, root);
    });

    document.querySelectorAll('[data-ftt-harvest-form]').forEach(function (form) {
      initHarvestForm(form);
    });

    document.querySelectorAll('[data-ftt-root="dashboard"]').forEach(renderDashboard);
    document.querySelectorAll('[data-ftt-root="recommendations"]').forEach(renderRecommendations);
    document.querySelectorAll('[data-ftt-recipe-favorite-scope]').forEach(bindFavoriteButtons);

    document.addEventListener('gg:favorites-updated', function () {
      document.querySelectorAll('[data-ftt-root="dashboard"]').forEach(renderDashboard);
      document.querySelectorAll('[data-ftt-root="recommendations"]').forEach(renderRecommendations);
      document.querySelectorAll('[data-ftt-root="profile"]').forEach(function (root) {
        ensureRootAccountState(root).favoriteRecipes = getFavoriteRecipes();
        renderProfileFavorites(root);
        bindProfileEditorButtons(root);
      });
      document.querySelectorAll('[data-ftt-recipe-favorite-scope]').forEach(bindFavoriteButtons);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-ftt-root="profile"]').forEach(function (root) {
        if (root.querySelector('[data-ftt-modal]:not([hidden])')) {
          closeAllProfileModals(root);
        }
      });
    });
  });

  window.GardenGamePlatform = {
    loadJson: async function (endpoint) {
      var response = await fetchWithTimeout(endpoint, { credentials: 'include' });
      if (!response.ok) {
        throw new Error('Garden & Game platform request failed');
      }
      return readJsonResponse(response);
    },
    emit: function (name, detail) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
    }
  };
})();
